import _ from 'lodash';
import timm from 'timm';

import { Types } from 'app/actions/actions';
import utils from 'app/reducers/utils';

const initialState = {};

const reducer = utils.createReducer(initialState, {

  [`${Types.FETCH}_RESOLVED`]: (state, {result: {actions}}) => {
    return timm.mergeDeep(state, utils.idMap(actions));
  },

  [`${Types.FETCH_MINE}_RESOLVED`]: (state, {result: {actions}}) => {
    return timm.mergeDeep(state, utils.idMap(actions));
  },

});

export default reducer;
